export const onboarding = {
  continue: "Continue",
  back: "Back",
  finish: "Finish",
  skip: "Skip for now",
  description: "Select at least 3",
  comicTypes: {
    title: "Tell us what types of comics you are most interested in.",
  },
  comicGenres: {
    title: "Select genres to shape your custom recommendations.",
  },
  comicThemes: {
    title: "Select themes that interest you the most.",
  },
  archetype: {
    title: "Start your comics journey.",
    subtitle: "Choose a path—change it anytime.",
    save: "Build my feed",
  },
  followComics: {
    title: "Now let’s add some books to your library.",
  },
  followAritsts: {
    title: "Almost done! Let’s follow some creators and publishers.",
  },
  splash: {
    title: "Welcome to GlobalComix!<1/>Your comics journey is just beginning.",
    startReading: "Start reading",
    continueReading: "Continue reading",
    continueToPurchase: "Continue to purchase book",
    goToLibrary: "Go to Library",
  },
  changeUsername: {
    title: "Welcome to the community!<1/>Claim your username.",
    usernameInstruction:
      "You can change these any time<1/>in your account settings.",
    placeholder: "username",
    publicProfileLabel: "Public Profile Address",
    continueButton: "Continue",
    saveButton: "Save",
    success: "Username saved!",
    errors: {
      usernameEmpty: "Username cannot be empty",
      usernameExists: "Username already exists",
      validationError: "An error occurred while validating username",
    },
  },
};
